import { UseStore } from '@eastcoal/common/types/zustand'
import { useContextStore } from '@eastcoal/common/utils/zustand'

import { AssignManagerStoreContext } from '../contexts/StoreContext'
import { AssignManagerStore } from '../store/interface'

export const useAssignManagerStore: UseStore<AssignManagerStore> = selector => {
  return useContextStore(AssignManagerStoreContext, selector)
}
